import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
    const { user, isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Failed to log out:', error);
        }
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const navLinkStyle = (path) => ({
        color: isActive(path) ? '#2563eb' : '#4b5563',
        textDecoration: 'none',
        padding: '0.5rem 1rem',
        borderRadius: '0.375rem',
        transition: 'all 0.2s',
        ':hover': {
            backgroundColor: '#f3f4f6'
        }
    });

    return (
        <nav style={{ backgroundColor: 'white', padding: '1rem', boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <Link to="/" style={navLinkStyle('/')}>
                        Home
                    </Link>
                    <Link to="/listings" style={navLinkStyle('/listings')}>
                        Listings
                    </Link>
                    {isAuthenticated && (
                        <>
                            <Link to="/my-listings" style={navLinkStyle('/my-listings')}>
                                My Listings
                            </Link>
                            <Link to="/my-purchases" style={navLinkStyle('/my-purchases')}>
                                My Purchases
                            </Link>
                        </>
                    )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    {isAuthenticated ? (
                        <>
                            <Link to="/profile" style={navLinkStyle('/profile')}>
                                Profile
                            </Link>
                            <button
                                onClick={handleLogout}
                                style={{
                                    padding: '0.5rem 1rem',
                                    backgroundColor: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '0.375rem',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                    ':hover': {
                                        backgroundColor: '#dc2626'
                                    }
                                }}
                            >
                                Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" style={navLinkStyle('/login')}>
                                Login
                            </Link>
                            <Link to="/register" style={{
                                ...navLinkStyle('/register'),
                                backgroundColor: '#2563eb',
                                color: 'white',
                                ':hover': {
                                    backgroundColor: '#1d4ed8'
                                }
                            }}>
                                Register
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navigation; 